const DialogView = require('./dialog_view')
const DialogBehavior = require('./dialog_behavior')
const alertDialog = require('./dialog_alert')
const errorDialog = require('./dialog_error')
const confirmDialog = require('./dialog_confirm')
const banner = require('./dialog_banner')
const loading = require('./dialog_loading')
require('./dialog_state')

const log = require('log').create('dialog'); // eslint-disable-line


module.exports = {
    View: DialogView,
    Behavior: DialogBehavior,
    alert: alertDialog,
    error: errorDialog,
    confirm: confirmDialog,
    banner,
    loading,
}
